// This route is deprecated, keeping file to avoid breaking bookmarks before <Redirect to="/org-dashboard" /> is evaluated.
export default {
  key: "org-activity-center",
  path: "/org-activity-center/:tab?",
  basePath: "org-activity-center",
};
